import { sendRequest } from "../base.service";

export const sendProductList = () => {
  return sendRequest("/home/product");
};
export const sendProductMenu = () => {
  return sendRequest("/product/menu");
};
export const getProductPagination = (id) => {
  return sendRequest(`/product/list/${id}`);
};
export const sendEnglishProductList = () => {
  return sendRequest("/home/en/product");
};
export const getSearchProducts = (page, q) => {
  return sendRequest("/product/search", "post", { id: page + "", q: q });
};
export const sendProductItem = (id) => {
  return sendRequest("/product/" + id);
};
export const sendRelatedItems = (id) => {
  return sendRequest("/product/related/" + id);
};
export const sendVSATProductItems = () => {
  return sendRequest("/vsat/product");
};
export const sendVSATTabProductItems = () => {
  return sendRequest("/vsat/product/tab");
};
export const sendVSATSatProductItems = () => {
  return sendRequest("/vsat/product/sat");
};
export const sendVSATCardProductItems = () => {
  return sendRequest("/vsat/product/card");
};
